const STORAGE_KEY = 'glyphicai-extra-params'

/** 读取存储的额外参数值 */
export function readStoredExtraParams(): Record<string, string> {
  try {
    const v = localStorage.getItem(STORAGE_KEY)
    if (!v) return {}
    const parsed = JSON.parse(v)
    if (typeof parsed !== 'object' || parsed === null) return {}
    return parsed as Record<string, string>
  } catch {
    return {}
  }
}

/** 持久化额外参数值 */
export function persistExtraParams(params: Record<string, string>): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(params))
  } catch {
    /* ignore */
  }
}

/** 清除存储的额外参数 */
export function clearStoredExtraParams(): void {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch {
    /* ignore */
  }
}
